import charitableContributions from './charitable-contributions';
import individualEmploymentIncome from './individual-employment-income';
import otherIncome from './other-income';

let messages = Object.assign({}, charitableContributions, individualEmploymentIncome, otherIncome);

export default messages;
